import type { Actor } from '@onefootprint/request-types/dashboard';

export const getAuthorName = (author?: Actor): string | null => {
  if (!author) {
    return null;
  }
  if (author.kind === 'organization') {
    if (author.firstName && author.lastName) {
      return `${author.firstName} ${author.lastName}`;
    }
    return author.email;
  }
  if (author.kind === 'firm_employee') {
    const name = [author.firstName, author.lastName].filter(Boolean).join(' ').trim();
    const display = name || author.email;
    return display ? `${display} (Footprint)` : 'Footprint';
  }
  return null;
};
